import React, { useState, useEffect } from "react";

// MUI Imports
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";

// Helper Imports
import {
  formatDate,
} from "./../../../Helpers/formatters";

// Icons
import BrandIcon from "./../../../Utilities/BrandIcon";

// Component Imports
import SuccessAlert from "./../../../Components/Interactive/SuccessAlert";
import FailAlert from "./../../../Components/Interactive/FailAlert";

const SelfOptOutRow = ({
  idx,
  row,
  selectForBulk,
  selectAll
}) => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [optOutRow, setOptOutRow] = useState(row);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
      setChecked(selectAll);   
  }, [selectAll]);

  const handleSelectChange = (e, id) => {
    setChecked(e.target.checked);
    selectForBulk(id);
  }

  const handleOptOutApprove = async (optOutId) => {
    clearMessages();
    const res = await fetch(`/api/optouts/approve`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ optOutIds: [optOutId] }),
    });
    const response = await res.json();
    if (response.success && response.result && response.result.length > 0) {
      setOptOutRow(response.result[0]);
      showSuccessMessage("Done: Opt-Out Approved successfully");
      setTimeout(() => clearMessages(), 5000);
    } else {
      console.error("error", response);
      showErrorMessage("Error: " + response.error);
      setTimeout(() => clearMessages(), 5000);
    }
  };

  const handleOptOutIgnore = async (optOutId) => {
    clearMessages();
    const res = await fetch(`/api/optouts/ignore`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ optOutIds: [optOutId] }),
    });
    const response = await res.json();
    if (response.success && response.result && response.result.length > 0) {
      setOptOutRow(response.result[0]);
      showSuccessMessage("Done: Opt-Out Ignored successfully");
      setTimeout(() => clearMessages(), 5000);
    } else {
      console.error("error", response);
      showErrorMessage("Error: " + response.error);
      setTimeout(() => clearMessages(), 5000);
    }
  };

  const clearMessages = async () => {
    setSuccessMessage(null);
    setErrorMessage(null);
  };

  const showErrorMessage = async (message) => {
    setSuccessMessage(null);
    setErrorMessage(message);
  };

  const showSuccessMessage = async (message) => {
    setErrorMessage(null);
    setSuccessMessage(message);
  };

  const getUserDisplayName = (optOutItem) => {
    if(optOutItem.approvedUserDisplayName)
      return optOutItem.approvedUserDisplayName;
    else if(isAutoIgnored(optOutItem) || isAutoApproved(optOutItem))
      return "System";
    else
      return "Unknown";
  };

  const isAutoIgnored = (optOutItem) => optOutItem.approvedStatus === "AutoIgnored";
  const isAutoApproved = (optOutItem) => optOutItem.approvedStatus === "AutoApproved";

  return (
    <TableRow className="order-row table-row" key={idx}>
      <TableCell  align="center" className="tableCell">
        <Checkbox checked={checked} onChange={(e) => handleSelectChange(e, optOutRow.id)} color="secondary"/>
      </TableCell>
      <TableCell align="center" className="tableCell">
        {optOutRow.email}
      </TableCell>
      <TableCell
        scope="row"
        className="tableCell"
        style={{ textAlign: "center !important" }}
      >
        <BrandIcon brandId={optOutRow.brandId} />
      </TableCell>
      <TableCell align="center" className="tableCell">
        {optOutRow.reportToken}
      </TableCell>
      <TableCell align="center" className="tableCell">
        {optOutRow.firstName} {optOutRow.lastName}
      </TableCell>
      <TableCell align="center" className="tableCell">
        {optOutRow.age}
      </TableCell>
      <TableCell align="center" className="tableCell">
        {optOutRow.location}
      </TableCell>
      <TableCell align="center" className="tableCell">
        {optOutRow.ipAddress}
      </TableCell>
      <TableCell
        align="center"
        className="tableCell"
        style={{ borderBottom: "none !important" }}
      >
        {formatDate(optOutRow.createdDate)}
      </TableCell>
      <TableCell align="center" className="tableCell">
        <span>
          {optOutRow.verifiedDate ? formatDate(optOutRow.verifiedDate) : ""}
        </span>
      </TableCell>
      <TableCell align="center" className="tableCell">
      {
        optOutRow.approvedDate != null ?
        (
          <>
            <span>
              {formatDate(optOutRow.approvedDate)}
            </span><br />
            <span>
              {optOutRow.approvedStatus} by {getUserDisplayName(optOutRow)}
            </span>
            <br/>
          </>
        ) : null
      }
      {
        optOutRow.approvedStatus !== "Approved" && !isAutoIgnored(optOutRow) && !isAutoApproved(optOutRow) && optOutRow.verifiedDate !== null ?
        (
          <>
          <button
            className="add-note-btn-open"
            onClick={(e) => handleOptOutApprove(optOutRow.id)}
          >
            <span style={{ color: "#fff" }}>Approve</span>
          </button>
          </>
        ) : null
      }
      {
        optOutRow.approvedStatus === "Pending" ?
        (
          <>
            <span>&nbsp;</span>
            <button
              className="add-note-btn-open"
              onClick={(e) => handleOptOutIgnore(optOutRow.id)}
            >
              <span style={{ color: "#fff" }}>Ignore</span>
            </button>
          </>
        ) : null
      }
    </TableCell>
      {
        successMessage ?
        (<div style={{ position: "fixed", top: "20px", right: "20px" }}>
          <SuccessAlert className="alert-animation" >
            {successMessage}
          </SuccessAlert>
        </div>
        )
        :
        errorMessage ?
          (<div style={{ position: "fixed", top: "20px", right: "20px" }}>
            <FailAlert>{errorMessage}</FailAlert>
          </div>)
          : null
      }
    </TableRow>
  );
};

export default SelfOptOutRow;
